module.exports = __webpack_public_path__ + "img/grand-osasis-cancun-5.8b127af8.jpg";